import fr from '@/internationalization/trans/chefs/fr/fr.json';
export default {
  trans: fr,
};
